<template>
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g opacity="0.35">
		<path d="M15 5L11.5858 1.58579C11.2107 1.21071 10.702 1 10.1716 1H3C1.89543 1 1 1.89543 1 3V19C1 20.1046 1.89543 21 3 21H9" :stroke="color" stroke-width="2"/>
		<path d="M14.5 5H11V1.5" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M5 13H9M5 16H9M7 9H9" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</g>
		<path d="M9 7C9 5.89543 9.89543 5 11 5H18.1716C18.702 5 19.2107 5.21071 19.5858 5.58579L22.4142 8.41421C22.7893 8.78929 23 9.29799 23 9.82843V23C23 24.1046 22.1046 25 21 25H11C9.89543 25 9 24.1046 9 23V7Z" :stroke="color" stroke-width="2"/>
		<path d="M22.5 9H19V5.5" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path opacity="0.35" d="M13 17H19M13 20H19M15 13H17" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>

<script>
  	export default {
    	name: 'moduleK',
    	props: ['color'],
    }
</script>